import * as React from 'react';
import 'react-step-progress-bar/styles.css';
import cl from 'classnames';

import s from './ProgressBar.module.css';

import InactiveSection from './InactiveSection';
import ActiveSection from './ActiveSection';

import {ProgressBar, Step} from 'react-step-progress-bar';

const stepPositions = [25, 50, 75, 100];
const progressWidth = '80%';

export default function Progress(props) {
  const {sections, testsTotal, testsCompleted, percent, current, order} = props;

  // This will calculate the percent increase of the progress bar based on the
  //currentSection
  const completionSectionProgressBar =
    (100 / Object.keys(sections).length) * (testsCompleted / testsTotal);

  // Current solution - take percent prop from parent which gives us the progress based on sections
  // 0 Sections finished = 0%, 1 section = 20%, then we add completionProgressBar to percent
  // Which will add to the progress bar based on the completion for a given section

  return (
    <ProgressBar
      className={s.ProgressBar}
      percent={percent + 100 / Object.keys(sections).length + completionSectionProgressBar}
      stepPositions={stepPositions}
      filledBackground="#cd212a"
      width={progressWidth}
    >
      {order.map(sectionName => {
        //Completion progress is going through the tests array for each section, and returning number of tests that have been completed using .length
        const sectionCompletionProgress =
          (sections[sectionName].tests.filter(test => test.status === 'complete').length /
            sections[sectionName].tests.length) *
          100;

        return (
          <Step transition="scale">
            {({accomplished}) =>
              accomplished ? (
                <div className={cl(s.StepWrapper, sectionName === current ? s.Current : '')}>
                  <div className={cl(s.SectionName, sectionName === current ? s.Current : '')}>
                    {sectionName}
                  </div>
                  <ActiveSection
                    sectionProgress={sectionCompletionProgress}
                    sectionName={sectionName}
                    order={order}
                  />
                </div>
              ) : (
                <div className={s.StepWrapper}>
                  <div className={s.SectionNameInactive}>{sectionName}</div>
                  <InactiveSection sectionName={sectionName} order={order} />
                </div>
              )
            }
          </Step>
        );
      })}
    </ProgressBar>
  );
}
